import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
import Index from '../view/Index'
import Vscode from '../view/Vscode'
import Plugin from '../view/plugin'
import TestRooRenderer from '../views/TestRooRenderer.vue'
import store from '../store'
import SsoLogin from '../view/SsoLogin'
import SsoSetup from '../view/SsoSetup'
import {usesUnifiedAuth,beginUnifiedLogin} from '../api/unifiedAuth'
// 安装路由
Vue.use(VueRouter);

// 配置导出路由
const router = new VueRouter({
  routes: [{path:"/sso/setup",component:SsoSetup}, {
    path: "/",
    redirect: "/home/index"
  },
  {
    name: "Index",
    path: '/index',
    component: Index
  },
  {
    name: "Login",
    path: '/login',
    component: usesUnifiedAuth() ? SsoLogin : Login
  },
  {
    name: "Register",
    path: '/register',
    component: usesUnifiedAuth() ? SsoLogin : Register
  },
  {
    name: "Vscode",
    path: '/vscode',
    component: Vscode
  },
  {
    name: "Plugin",
    path: '/plugin',
    component: Plugin
  },
  {
    name: "TestRooRenderer",
    path: '/test-roo-renderer',
    component: TestRooRenderer
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "HomeIndex",
        path: "/home/index",
        component: Index,
        meta: { requiresAuth: false }  // 免登录访问
      },
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
        meta: { requiresAuth: true }  // 需要登录
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
        meta: { requiresAuth: true }  // 需要登录
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
        meta: { requiresAuth: true }  // 需要登录
      }
    ]
  },
  {
    name: "MessageRendererDemo",
    path: '/demo/message-renderer',
    component: () => import("../components/message/MessageRendererDemo"),
  },
  {
    name: "TestMermaid",
    path: '/test-mermaid',
    component: () => import("../views/TestMermaid"),
  },
  {
    name: "AgentProfile",
    path: '/agent/profile/:shareId',
    component: () => import("../view/AgentProfile"),
    meta: { requiresAuth: false }  // 无需登录即可访问
  },
  {
    name: "AgentProfileByAgentId",
    path: '/agent/profile/a/:agentId',
    component: () => import("../view/AgentProfile"),
    meta: { requiresAuth: false }  // 无需登录即可访问
  },
  {
    name: "HelpPricing",
    path: '/help/pricing',
    component: () => import("../view/HelpPricing"),
    meta: { requiresAuth: false }  // 无需登录即可访问
  },
  ]

});

// 路由守卫：检查登录状态
router.beforeEach((to, from, next) => {
  if (usesUnifiedAuth() && ['/login', '/register'].includes(to.path)) {
    const requested = to.query.redirect;
    const target = typeof requested === 'string' && requested.startsWith('/') && !requested.startsWith('//')
      ? requested : (from.matched.length ? from.fullPath : undefined);
    beginUnifiedLogin(target);
    return;
  }
  const hasToken = sessionStorage.getItem('accessToken');
  const isLoggedIn = store.getters.isLoggedIn;
  
  // 需要登录的路由
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!hasToken || !isLoggedIn) {
      if(usesUnifiedAuth()){beginUnifiedLogin(to.fullPath);return;}
      // 未登录，跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
